<div class="p-4 overflow-auto h-[85vh]">

  <div class="flex justify-between -mt-4">
    <h2 class="text-xl font-semibold">Campuses</h2>
    <p-button icon="pi pi-plus" label="Add Campus" (click)="openAddModal()" class="mb-3"></p-button>
  </div>

  <p-table [value]="campuses" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
    (onLazyLoad)="loadCampuses($event)" [loading]="loading">

    <ng-template pTemplate="header">
      <tr>
        <th>Campus Name</th>
        <th>City</th>
        <th>State</th>
        <th>Code</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-campus>
      <tr>
        <td>{{ campus.name }}</td>
        <td>{{ campus.city }}</td>
        <td>{{ campus.state }}</td>
        <td>{{ campus.code }}</td>
        <td>{{ campus.status }}</td>
        <td>
          <div (click)="setCampusData(campus)">
            <p-menu [tabindex]="undefined" #menu [model]="campusActionItem" [popup]="true" appendTo="body"></p-menu>
            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loading">
      <tr>
        <td colspan="3" class="text-center">
          <p-progressSpinner></p-progressSpinner>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="7" class="no-data">
          <p>No records found</p>
        </td>
      </tr>
    </ng-template>
  </p-table>


</div>

<ng-container *ngIf="displayAddModal">
<p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
  <app-create-campus 
  (reload)="reload()" 
  [orgId]="orgId" (close)="closeAddModal()"></app-create-campus>
</p-dialog>
</ng-container>



<ng-container *ngIf="showEditCampus">
  <p-dialog [(visible)]="showEditCampus" [modal]="true" [style]="{width: '50rem'}" [closable]="false">
    <app-create-campus 
    (reload)="reload()" 
    [orgId]="orgId" [type]="'Update'" [campusDataToEdit]="campusDataToEdit"
      (close)="showEditCampus = false"></app-create-campus>
  </p-dialog>
</ng-container>

<ng-container *ngIf="showDeleteCampus">
  <p-dialog [(visible)]="showDeleteCampus" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
    <app-delete-campus
    [orgId]="orgId" 
    (reload)="reload()"
    [campusDataToEdit]="campusDataToEdit"
      (close)="showDeleteCampus = false"></app-delete-campus>
  </p-dialog>
</ng-container>